import { FunctionComponent } from "react";
import InputFormField, { PropsType } from "@components/inputs/InputFormField";
import i18n from "i18next";

export const EMAIL_REGEX = /^([\w-\.+]+)@((?:[\w-\.]+\.)+)([a-zA-Z]{2,4})/i;

const MailFormField: FunctionComponent<PropsType> = (props: PropsType) => {
  const { rules, field } = props;

  return (
    <InputFormField
      {...props}
      rules={[
        ...(rules || []),
        {
          pattern: new RegExp(EMAIL_REGEX),
          message: (
            <span data-test={`error-${String(field)}`}>
              {i18n.t("forms.errors.email-invalid")}
            </span>
          ),
        },
      ]}
    />
  );
};

export default MailFormField;
